import { Phone, Mail, MapPin, MessageSquare, Clock } from "lucide-react";
import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import QuoteForm from "@/components/QuoteForm";
import { SITE } from "@/data/site";

export default function Contact() {
  return (
    <>
      <Seo
        title="Contact"
        description="Contact Kensmarc Electric — call (626) 539-5844 or (818) 310-3235, email kensmarc@gmail.com, or request a quote online. Serving 91702 and Los Angeles County."
        path="/contact"
      />
      <PageHeader
        eyebrow="Contact"
        title="Get in touch"
        subtitle="Call, email, or send a quote request. Kensmarc Electric serves 91702 and the surrounding Los Angeles County area."
      />

      <section className="section-pad">
        <div className="container-kx grid gap-12 lg:grid-cols-[0.85fr_1.15fr]">
          <div className="space-y-4">
            <a href={SITE.phonePrimary.tel} data-testid="contact-call-primary" className="kx-card kx-card-hover flex items-center gap-4 p-5">
              <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-amber-400/10 text-amber-400"><Phone className="h-6 w-6" /></div>
              <div>
                <p className="text-xs uppercase tracking-widest text-neutral-500">Primary phone</p>
                <p className="text-lg font-semibold text-white">{SITE.phonePrimary.display}</p>
              </div>
            </a>
            <a href={SITE.phoneSecondary.tel} data-testid="contact-call-secondary" className="kx-card kx-card-hover flex items-center gap-4 p-5">
              <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-amber-400/10 text-amber-400"><Phone className="h-6 w-6" /></div>
              <div>
                <p className="text-xs uppercase tracking-widest text-neutral-500">Secondary phone</p>
                <p className="text-lg font-semibold text-white">{SITE.phoneSecondary.display}</p>
              </div>
            </a>
            <a href={SITE.emailHref} data-testid="contact-email" className="kx-card kx-card-hover flex items-center gap-4 p-5">
              <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-amber-400/10 text-amber-400"><Mail className="h-6 w-6" /></div>
              <div>
                <p className="text-xs uppercase tracking-widest text-neutral-500">Email</p>
                <p className="text-lg font-semibold text-white">{SITE.email}</p>
              </div>
            </a>
            <div className="kx-card flex items-center gap-4 p-5">
              <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-amber-400/10 text-amber-400"><MapPin className="h-6 w-6" /></div>
              <div>
                <p className="text-xs uppercase tracking-widest text-neutral-500">Service area</p>
                <p className="text-base font-semibold text-white">{SITE.serviceZip} & surrounding areas</p>
                <p className="text-sm text-neutral-400">{SITE.county}</p>
              </div>
            </div>
            <div className="kx-card flex items-start gap-4 p-5" data-testid="contact-hours">
              <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-amber-400/10 text-amber-400"><Clock className="h-6 w-6" /></div>
              <div className="flex-1">
                <p className="text-xs uppercase tracking-widest text-neutral-500">Business hours</p>
                <ul className="mt-1.5 space-y-1">
                  {SITE.hours.display.map((h) => (
                    <li key={h.days} className="flex items-center justify-between gap-4 text-sm">
                      <span className="text-neutral-300">{h.days}</span>
                      <span className={h.time === "Closed" ? "font-semibold text-neutral-500" : "font-semibold text-white"}>{h.time}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="rounded-xl border border-amber-400/25 bg-amber-400/5 p-5">
              <p className="flex items-center gap-2 font-semibold text-amber-300"><MessageSquare className="h-5 w-5" /> Fastest response</p>
              <p className="mt-1 text-sm text-neutral-300">Use the quote form so Marcos gets all your project details up front.</p>
            </div>
          </div>

          <div>
            <h2 className="mb-4 font-display text-2xl font-bold uppercase text-white">Request a quote</h2>
            <QuoteForm />
          </div>
        </div>
      </section>
    </>
  );
}
